// extracted by mini-css-extract-plugin
module.exports = {"RatingControler":"RatingController_RatingControler__38ybp","RatingControler-Title":"RatingController_RatingControler-Title__ZIz3A"};